module.exports = __webpack_public_path__ + "img/deskshelf03.405fc880.jpg";